import React, { useEffect } from 'react';
import InputField from '../../kit/InputField';
import { useTranslation } from 'react-i18next';

/**
 * BasicInfo section of the Contact form.
 * @param {object} props
 * @param {object} props.contact - The initial contact data from a prop.
 * @param {function} props.onUpdate - Callback to bubble state changes back up.
 */
export default function BasicInfo({ contact: initialContact, onUpdate }) {
  const { t } = useTranslation();

  // Initialize state from prop
  const [contact, setContact] = React.useState({
    firstName: initialContact?.firstName || '',
    lastName: initialContact?.lastName || '',
    email: initialContact?.email || '',
  });

  const [formErrors, setFormErrors] = React.useState({
    firstName: null,
    lastName: null,
    email: null,
  });

  // Keep local state in sync if the prop changes (e.g., after an API fetch)
  useEffect(() => {
    if (initialContact) {
      setContact(initialContact);
    }
  }, [initialContact]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedContact = { ...contact, [name]: value };
    
    setContact(updatedContact);

    // Bubble the change up to the parent container (Edit/New Contact)
    if (onUpdate) {
      onUpdate(updatedContact);
    }
  };

  return (
    <div className="space-y-4">
      <InputField
        label={t("basic_info_first_name_input_label")}
        name="firstName"
        placeholder={t("basic_info_first_name_input_placeholder")}
        required={true}
        value={contact.firstName}
        onChange={handleChange}
        error={formErrors.firstName}
      />

      <InputField
        label={t("basic_info_last_name_input_label")}
        name="lastName"
        placeholder={t("basic_info_last_name_input_placeholder")}
        required={true}
        value={contact.lastName}
        onChange={handleChange}
        error={formErrors.lastName}
      />

      <InputField
        label={t("basic_info_email_input_label")}
        name="email"
        placeholder={t("basic_info_email_input_placeholder")}
        type="email"
        required={true}
        value={contact.email}
        onChange={handleChange}
        error={formErrors.email}
      />
    </div>
  );
}